import React from 'react';
import PropTypes from 'prop-types';

export default function CustomFieldAddRow(props) {
    const onClick = (e) => {
        e.stopPropagation();
        props.onClick();
    };

    return <div className="gd-list-add" onClick={onClick}>{props.label ? props.label : "+ New Item"}</div>;
}

CustomFieldAddRow.propTypes = {
    label: PropTypes.string,

    onClick: PropTypes.func,
}